import Vue from 'vue';
import insBlockItem from './ins-detail-block.vue';
export default Vue.extend({
    components: {
        insBlockItem: insBlockItem,
    },
    props: {
        claimId: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            basicTitle: '基础信息',
            basicData: [
                {
                    label: '驾驶员',
                    value: '李思思',
                },
                {
                    label: '驾照号',
                    value: 'A1111110000',
                },
                {
                    label: '驾龄',
                    value: '3years',
                },
                {
                    label: '车牌号',
                    value: '京AH1234',
                },
                {
                    label: 'Vin码',
                    value: 'ABC123456789',
                },
            ],
            carInsuranceTitle: '保单信息',
            carInsuranceData: [
                {
                    label: '保单号',
                    value: 'H12312300000',
                },
                {
                    label: '起期',
                    value: '2019-01-01',
                },
                {
                    label: '止期',
                    value: '2019-12-31',
                },
                {
                    label: '保单类型',
                    value: '交强险',
                },
            ],
        };
    },
    methods: {},
});
